<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">User Login History</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a [routerLink]="[getDashboardRoute()]" href="javascript:void(0);">
              <i class="ti ti-smart-home"></i>
            </a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">User Login History</li>
        </ol>
      </nav>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <!-- Summary Cards -->
  <div class="row">
    <!-- Total Logins -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center">
          <span class="avatar avatar-lg bg-primary flex-shrink-0">
            <i class="ti ti-login fs-16"></i>
          </span>

          <div class="ms-2 overflow-hidden">
            <p class="fs-12 fw-medium mb-1 text-truncate">Total Logins</p>
            <h4>{{ totalRowCount$ | async }}</h4>
          </div>
        </div>
      </div>
    </div>

    <!-- Successful Logins -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center">
          <span class="avatar avatar-lg bg-success flex-shrink-0">
            <i class="ti ti-circle-check fs-16"></i>
          </span>

          <div class="ms-2 overflow-hidden">
            <p class="fs-12 fw-medium mb-1 text-truncate">Successful Logins</p>
            <h4>{{ successCount$ | async }}</h4>
          </div>
        </div>
      </div>
    </div>

    <!-- Failed Logins -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center">
          <span class="avatar avatar-lg bg-danger flex-shrink-0">
            <i class="ti ti-alert-circle fs-16"></i>
          </span>

          <div class="ms-2 overflow-hidden">
            <p class="fs-12 fw-medium mb-1 text-truncate">Failed Logins</p>
            <h4>{{ failedCount$ | async }}</h4>
          </div>
        </div>
      </div>
    </div>

    <!-- Logged Out -->
    <!-- <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center">
          <span class="avatar avatar-lg bg-warning flex-shrink-0">
            <i class="ti ti-logout fs-16"></i>
          </span>

          <div class="ms-2 overflow-hidden">
            <p class="fs-12 fw-medium mb-1 text-truncate">Logged Out</p>
            <h4>{{ loggedOutCount$ | async }}</h4>
          </div>
        </div>
      </div>
    </div> -->
  </div>
  <!-- /Summary Cards -->

  <!-- Login History List -->
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <h5>User Login History</h5>

      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <!-- Entries -->
        <div class="me-3">
          <select
            class="form-select form-select-sm"
            id="entries"
            name="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">
              {{ limit }}
            </option>
          </select>
        </div>
        <ng-select
          *appHasPermission="{ business: ['view'], employees: ['view'] }"
          class="me-3"
          [items]="businesses$ | async"
          bindValue="id"
          placeholder="Select Business Entity"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
          [(ngModel)]="selectedBusinessId"
          (change)="onBusinessChange(selectedBusinessId)"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
        </ng-select>

        <ng-select
          *appHasPermission="{ employees: ['view'] }"
          class="me-3"
          [items]="employees$ | async"
          bindValue="id"
          placeholder="Select Employee"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFnEmployee"
          style="width: 200px"
          [(ngModel)]="selectedEmployeeId"
          (change)="onEmployeeChange(selectedEmployeeId)"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
          </ng-template>
        </ng-select>

        <!-- Status -->
        <div class="dropdown me-3">
          <select class="form-select" [(ngModel)]="status" (change)="setCurrentPage()">
            <option value="">Select Status</option>
            <option value="success">Success</option>
            <option value="failed">Failed</option>
            <!-- <option value="logged_out">Logged Out</option> -->
          </select>
        </div>

        <!-- Login Method -->
        <!-- <div class="dropdown me-3">
          <select class="form-select" [(ngModel)]="loginMethod" (change)="setCurrentPage()">
            <option value="">Login Method</option>
            <option value="password">Password</option>
            <option value="google">Google</option>
            <option value="microsoft">Microsoft</option>
            <option value="sso">SSO</option>
          </select>
        </div> -->

        <!-- Search -->
        <!-- <div class="form-sort search-box">
          <label>
            <input
              appTrimInput
              type="search"
              class="form-control"
              placeholder="Search user..."
              [(ngModel)]="search"
              (input)="setCurrentPage()"
            />
          </label>
        </div> -->
      </div>
    </div>

    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <ng-container *ngIf="loginHistory$ | async as histories">
          <table class="table datatable" *ngIf="histories.length > 0; else noRecords">
            <thead class="thead-light">
              <tr>
                <th>User</th>
                <th>Business</th>
                <th>Device</th>
                <th>Login</th>
                <!-- <th>IP Address</th> -->
                <!-- <th>User Agent</th> -->
                <!-- <th>Login Location</th> -->
                <th>Logout</th>
                <!-- <th>IP Address</th>
                <th>LogOut Location</th> -->
                <!-- <th>Method</th> -->
                <th>Status</th>
                <!-- <th class="text-end">Action</th> -->
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let history of histories">
                <!-- User -->
                <td>
                  <div class="d-flex align-items-center file-name-icon">
                    <span
                      class="avatar avatar-md border rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                    >
                      {{ getInitials(history.user?.firstName + ' ' + history.user?.lastName) }}
                    </span>

                    <div class="ms-2">
                      <h6 class="fw-medium mb-0">
                        {{ history.user ? (history.user.firstName | capitalize) : 'N/A' }}
                        {{ history.user ? (history.user.lastName | capitalize) : '' }}
                      </h6>

                      <small class="text-muted">
                        {{ history.user?.email || 'N/A' }}
                      </small>
                    </div>
                  </div>
                </td>
                <td>{{ history.user.business.businessName ?? '' }}</td>

                <!-- Device -->
                <td>
                  <div *ngIf="history.device; else noDevice" class="d-flex align-items-center">
                    <!-- <span class="avatar avatar-sm bg-light me-2">
                      <i
                        [ngClass]="
                          history.device?.deviceType === 'mobile'
                            ? 'ti ti-device-mobile'
                            : 'ti ti-device-desktop'
                        "
                      ></i>
                    </span> -->

                    <div>
                      <span class="d-block fw-medium">
                        <!-- {{ history.device?.deviceName || 'Unknown Device' }} -->
                        {{ history.device?.os || 'Unknown OS' }}
                      </span>

                      <!-- <small class="text-muted">
                        {{ history.device?.os || 'Unknown OS' }}
                      </small> -->
                    </div>
                  </div>

                  <ng-template #noDevice>
                    <span class="text-muted">Unknown Device</span>
                  </ng-template>
                </td>

                <!-- Login Details -->
                <td>
                  <div class="d-flex flex-column gap-1">
                    <!-- Login Date -->
                    <span>
                      <i class="ti ti-calendar me-1"></i>
                      {{ history.loginTime | date: 'medium' }}
                    </span>

                    <!-- Login IP -->
                    <span class="text-muted">
                      <i class="ti ti-world me-1"></i>
                      {{ history.ipAddress || 'N/A' }}
                    </span>

                    <!-- Login Location -->
                    <span class="text-muted">
                      <i class="ti ti-map-pin me-1"></i>
                      <ng-container
                        *ngIf="
                          history.loginLatitude !== null && history.loginLongitude !== null;
                          else noLoginLocation
                        "
                      >
                        {{ history.loginLatitude }}, {{ history.loginLongitude }}
                      </ng-container>

                      <ng-template #noLoginLocation> N/A </ng-template>
                    </span>
                  </div>
                </td>

                <!-- Logout Details -->
                <td>
                  <div class="d-flex flex-column gap-1">
                    <!-- Logout Date -->
                    <span>
                      <i class="ti ti-calendar me-1"></i>
                      <ng-container *ngIf="history.logoutTime; else notLoggedOut">
                        {{ history.logoutTime | date: 'medium' }}
                      </ng-container>

                      <ng-template #notLoggedOut>
                        <span class="text-muted">-</span>
                      </ng-template>
                    </span>

                    <!-- Logout IP -->
                    <span class="text-muted">
                      <i class="ti ti-world me-1"></i>
                      {{ history.logoutIpAddress || 'N/A' }}
                    </span>

                    <!-- Logout Location -->
                    <span class="text-muted">
                      <i class="ti ti-map-pin me-1"></i>
                      <ng-container
                        *ngIf="
                          history.logoutLatitude !== null && history.logoutLongitude !== null;
                          else noLogoutLocation
                        "
                      >
                        {{ history.logoutLatitude }}, {{ history.logoutLongitude }}
                      </ng-container>

                      <ng-template #noLogoutLocation> N/A </ng-template>
                    </span>
                  </div>
                </td>

                <!-- Login Time -->
                <!-- <td>
                  {{ history.loginTime | date: 'medium' }}
                </td> -->

                <!-- IP Address -->
                <!-- <td>
                  <span class="text-muted">
                    {{ history.ipAddress || 'N/A' }}
                  </span>
                </td> -->

                <!-- User Agent -->
                <!-- <td>
                  <div
                    class="text-truncate"
                    style="max-width: 250px"
                    [title]="history.userAgent || 'N/A'"
                  >
                    {{ history.userAgent || 'N/A' }}
                  </div>
                </td> -->

                <!-- Login Location -->
                <!-- <td>
                  <ng-container
                    *ngIf="
                      history.loginLatitude !== null && history.loginLongitude !== null;
                      else noLoginLocation
                    "
                  >
                    <span class="d-block">
                      <i class="ti ti-map-pin me-1"></i>
                      {{ history.loginLatitude }},
                      {{ history.loginLongitude }}
                    </span>
                  </ng-container>

                  <ng-template #noLoginLocation>
                    <span class="text-muted">N/A</span>
                  </ng-template>
                </td> -->

                <!-- Logout -->
                <!-- <td>
                  <ng-container *ngIf="history.logoutTime; else notLoggedOut">
                    {{ history.logoutTime | date: 'medium' }}
                  </ng-container>

                  <ng-template #notLoggedOut>
                    <span class="text-muted">-</span>
                  </ng-template>
                </td>

                <td>
                  <span class="text-muted">
                    {{ history.logoutIpAddress || 'N/A' }}
                  </span>
                </td>

                <td>
                  <ng-container
                    *ngIf="
                      history.logoutLatitude !== null && history.logoutLongitude !== null;
                      else noLogoutLocation
                    "
                  >
                    <span class="d-block">
                      <i class="ti ti-map-pin me-1"></i>
                      {{ history.logoutLatitude }},
                      {{ history.logoutLongitude }}
                    </span>
                  </ng-container>

                  <ng-template #noLogoutLocation>
                    <span class="text-muted">N/A</span>
                  </ng-template>
                </td> -->

                <!-- Login Method -->
                <!-- <td>
                  <span class="badge badge-light d-inline-flex">
                    {{ history.loginMethod || 'N/A' }}
                  </span>
                </td> -->

                <!-- Status -->
                <td>
                  <span
                    *ngIf="history.status === 'success'"
                    class="badge badge-success d-inline-flex align-items-center badge-xs"
                  >
                    <i class="ti ti-circle-check me-1"></i>
                    Success
                  </span>

                  <!-- Failed -->
                  <div *ngIf="history.status === 'failed'">
                    <span class="badge badge-danger d-inline-flex align-items-center badge-xs">
                      <i class="ti ti-alert-circle me-1"></i> Failed
                    </span>
                    <!-- Failure Reason -->
                    <div
                      *ngIf="history.failureReason"
                      class="text-danger fs-12 mt-1"
                      style="max-width: 220px"
                    >
                      <i class="ti ti-info-circle me-1"></i> {{ history.failureReason }}
                    </div>
                    <!-- If failure reason is not available -->
                    <div *ngIf="!history.failureReason" class="text-muted fs-12 mt-1">
                      Reason not available
                    </div>
                  </div>

                  <span
                    *ngIf="history.status === 'logged_out'"
                    class="badge badge-warning d-inline-flex align-items-center badge-xs"
                  >
                    <i class="ti ti-logout me-1"></i>
                    Logged Out
                  </span>
                </td>

                <!-- Action -->
                <!-- <td class="text-end">
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      (click)="openLoginHistoryDetails(history)"
                    >
                      <i class="ti ti-eye"></i>
                    </a>
                  </div>
                </td> -->
              </tr>
            </tbody>
          </table>
        </ng-container>

        <ng-template #noRecords>
          <div class="text-center p-4">Record not available</div>
        </ng-template>
      </div>
    </div>

    <!-- Pagination -->
    <ng-container *ngIf="loginHistory$ | async as histories">
      <div
        class="d-flex align-items-center justify-content-between ms-2 me-2"
        *ngIf="histories.length > 0"
      >
        <div>
          Showing
          {{ (currentPage - 1) * pageLimit + 1 }}
          to
          {{ pageLastRecord }}
          of
          {{ totalRowCount }}
          entries
        </div>

        <div class="has-text-centered mt-3">
          <app-pagination
            [currentPage]="currentPage"
            [pageSize]="pageLimit"
            [totalRows]="totalRowCount"
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      </div>
    </ng-container>
    <!-- /Pagination -->
  </div>
  <!-- /Login History List -->
</div>
```
